export class ServiceWorkerManager {
  private modelCachedCallback?: (cached: boolean) => void;

  async register(onModelCached?: (cached: boolean) => void): Promise<void> {
    this.modelCachedCallback = onModelCached;

    if ("serviceWorker" in navigator) {
      try {
        const registration = await navigator.serviceWorker.register("/service-worker.js");
        console.log("Service Worker registered:", registration);

        // Wait for the service worker to be ready (active and controlling)
        await navigator.serviceWorker.ready;
        
        // If no controller yet, wait for it (happens on first visit)
        if (!navigator.serviceWorker.controller) {
          await new Promise<void>((resolve) => {
            navigator.serviceWorker.addEventListener("controllerchange", () => {
              resolve();
            }, { once: true });
            
            // Fallback timeout in case controllerchange doesn't fire
            setTimeout(() => resolve(), 1000);
          });
        }

        // Listen for cache status messages
        navigator.serviceWorker.addEventListener("message", (event) => {
          if (event.data && event.data.type === "model-cache-hit") {
            if (this.modelCachedCallback) {
              this.modelCachedCallback(true);
            }
            console.log("Model loaded from cache!");
          } else if (event.data && event.data.type === "model-cached") {
            console.log("Model cached for future use");
          }
        });

        // Check if model is already cached
        if (navigator.serviceWorker.controller) {
          const messageChannel = new MessageChannel();
          messageChannel.port1.onmessage = (event) => {
            if (event.data && event.data.hasCached) {
              if (this.modelCachedCallback) {
                this.modelCachedCallback(true);
              }
              console.log("Model already in cache");
            }
          };
          navigator.serviceWorker.controller.postMessage(
            { type: "check-cache" },
            [messageChannel.port2]
          );
        }
      } catch (error) {
        console.warn("Service Worker registration failed:", error);
        // Continue without service worker
      }
    }
  }

  async clearCache(): Promise<void> {
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      return new Promise((resolve) => {
        const messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = (event) => {
          if (event.data && event.data.success) {
            console.log(
              "🗑️ Model cache cleared! The model will be re-downloaded on next visit."
            );
            alert("Model cache cleared! Refresh the page to re-download.");
            resolve();
          }
        };
        navigator.serviceWorker.controller.postMessage({ type: "clear-cache" }, [
          messageChannel.port2,
        ]);
      });
    } else {
      console.log("Service worker not available");
    }
  }
}